import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Tooltip, VocLarge } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { StreamData } from 'types/streamData'
import { StyledDomainLink } from '../index.css'

type LinkedVocIconProps = {
  streamData: StreamData
}

const LinkedVocIcon = ({ streamData }: LinkedVocIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const { domain, url } = streamData

  return (
    <Tooltip mode={theme} enabled content={!url ? t('soundbiteNoUrl') : `VoC: ${domain}`}>
      <StyledDomainLink
        href={!url ? undefined : `https://${domain}`}
        target="_blank"
        rel="noreferrer"
        disabled={!url}
        onClick={(event) => {
          event.stopPropagation()
        }}>
        <VocLarge fontSize={16} mode={theme} />
      </StyledDomainLink>
    </Tooltip>
  )
}

export default LinkedVocIcon
